import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "viewBox": "-7.5 -8 2463.75 673.3783569335938",
        "style": {
          "maxWidth": "2463.75px"
        },
        "aria-labelled-by": ["chart-title-mermaid-1694798718206", "chart-desc-mermaid-1694798718206"],
        "role": "img",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "100%",
        "id": "mermaid-1694798718206"
      }}><title parentName="svg" {...{
          "id": "chart-title-mermaid-1694798718206"
        }}></title><desc parentName="svg" {...{
          "id": "chart-desc-mermaid-1694798718206"
        }}></desc><style parentName="svg">{`#mermaid-1694798718206 {font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1694798718206 .error-icon{fill:#552222;}#mermaid-1694798718206 .error-text{fill:#552222;stroke:#552222;}#mermaid-1694798718206 .edge-thickness-normal{stroke-width:2px;}#mermaid-1694798718206 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1694798718206 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1694798718206 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1694798718206 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1694798718206 .marker{fill:#333333;stroke:#333333;}#mermaid-1694798718206 .marker.cross{stroke:#333333;}#mermaid-1694798718206 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1694798718206 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1694798718206 .cluster-label text{fill:#333;}#mermaid-1694798718206 .cluster-label span{color:#333;}#mermaid-1694798718206 .label text,#mermaid-1694798718206 span{fill:#333;color:#333;}#mermaid-1694798718206 .node rect,#mermaid-1694798718206 .node circle,#mermaid-1694798718206 .node ellipse,#mermaid-1694798718206 .node polygon,#mermaid-1694798718206 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1694798718206 .node .label{text-align:center;}#mermaid-1694798718206 .node.clickable{cursor:pointer;}#mermaid-1694798718206 .arrowheadPath{fill:#333333;}#mermaid-1694798718206 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1694798718206 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1694798718206 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1694798718206 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1694798718206 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1694798718206 .cluster text{fill:#333;}#mermaid-1694798718206 .cluster span{color:#333;}#mermaid-1694798718206 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1694798718206 :root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}#mermaid-1694798718206 .sgraph>*{fill:#fff!important;stroke-width:3px!important;stroke-dasharray:5!important;stroke:#000!important;}#mermaid-1694798718206 .sgraph span{fill:#fff!important;stroke-width:3px!important;stroke-dasharray:5!important;stroke:#000!important;}#mermaid-1694798718206 .cluster>*{fill:#fff!important;stroke:#bbb!important;stroke-width:2px!important;color:#326ce5!important;}#mermaid-1694798718206 .cluster span{fill:#fff!important;stroke:#bbb!important;stroke-width:2px!important;color:#326ce5!important;}#mermaid-1694798718206 .OptionalServices>*{fill:#848383!important;}#mermaid-1694798718206 .OptionalServices span{fill:#848383!important;}`}</style><g parentName="svg"><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "12",
            "markerWidth": "12",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "9",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-pointEnd"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 0 0 L 10 5 L 0 10 z"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "12",
            "markerWidth": "12",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "0",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-pointStart"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 0 5 L 10 10 L 10 0 z"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "11",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-circleEnd"
          }}><circle parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "r": "5",
              "cy": "5",
              "cx": "5"
            }}></circle></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "-1",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-circleStart"
          }}><circle parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "r": "5",
              "cy": "5",
              "cx": "5"
            }}></circle></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5.2",
            "refX": "12",
            "viewBox": "0 0 11 11",
            "className": "marker cross flowchart",
            "id": "flowchart-crossEnd"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "2",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 1,1 l 9,9 M 10,1 l -9,9"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5.2",
            "refX": "-1",
            "viewBox": "0 0 11 11",
            "className": "marker cross flowchart",
            "id": "flowchart-crossStart"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "2",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 1,1 l 9,9 M 10,1 l -9,9"
            }}></path></marker><g parentName="g" {...{
            "className": "root"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}></g><g parentName="g" {...{
              "className": "edgePaths"
            }}></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "transform": "translate(-7.5, -8)",
                "className": "root"
              }}><g parentName="g" {...{
                  "className": "clusters"
                }}><g parentName="g" {...{
                    "id": "Wrapper",
                    "className": "cluster default"
                  }}><rect parentName="g" {...{
                      "height": "657.3783311843872",
                      "width": "2447.75",
                      "y": "8",
                      "x": "8",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(1231.875, 13)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "PluginServer",
                    "className": "cluster default"
                  }}><rect parentName="g" {...{
                      "height": "617.3783311843872",
                      "width": "1856.75",
                      "y": "28",
                      "x": "33",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(961.375, 33)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "MainThread",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "524",
                      "width": "196.109375",
                      "y": "101.3783311843872",
                      "x": "58",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(108.1875, 106.3783311843872)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "95.734375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Main thread`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "WorkerThread",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "503.2737159729004",
                      "width": "1440.375",
                      "y": "117.25",
                      "x": "424.375",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(1087.609375, 122.25)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "113.90625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Worker thread`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "edgePaths"
                }}><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-0",
                    "d": "M229.109375,153.3783311843872L233.27604166666666,153.3783311843872C237.44270833333334,153.3783311843872,245.77604166666666,153.3783311843872,254.109375,153.3783311843872C262.4427083333333,153.3783311843872,270.7760416666667,153.3783311843872,283.72090833705397,173.37259006500244C296.66577500744125,193.36684894561768,314.22217501488245,233.35536670684814,323.0003750186031,253.34962558746338L331.7785750223237,273.3438844680786"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-PubSub LE-Piscina",
                    "id": "L-PubSub-Piscina-0",
                    "d": "M193.6171875,237.3783311843872L203.69921875,237.3783311843872C213.78125,237.3783311843872,233.9453125,237.3783311843872,248.19401041666666,237.3783311843872C262.4427083333333,237.3783311843872,270.7760416666667,237.3783311843872,281.74810586054997,243.37259006500244C292.7201700544333,249.36684894561768,306.3309651088667,261.35536670684814,313.13636263608333,267.3496255874634L319.9417601633,273.3438844680786"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Graphile LE-Piscina",
                    "id": "L-Graphile-Piscina-0",
                    "d": "M225.0703125,321.3783311843872L229.91015625,321.3783311843872C234.75,321.3783311843872,244.4296875,321.3783311843872,253.43619791666666,321.3783311843872C262.4427083333333,321.3783311843872,270.7760416666667,321.3783311843872,279.4749343070905,319.0392567316691C288.1738269475144,316.700182278951,297.23827889502877,312.02203337351483,301.77050486878596,309.6829589207967L306.30273084254316,307.3438844680786"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Schedule LE-Piscina",
                    "id": "L-Schedule-Piscina-0",
                    "d": "M200.3203125,405.3783311843872L209.28515625,405.3783311843872C218.25,405.3783311843872,236.1796875,405.3783311843872,249.31119791666666,405.3783311843872C262.4427083333333,405.3783311843872,270.7760416666667,405.3783311843872,283.4837543289894,389.0392567316691C296.1914669913121,372.700182278951,313.27355898262425,340.02203337351483,321.81460497828033,323.6829589207967L330.35565097393635,307.3438844680786"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Piscina LE-WorkerTasks",
                    "id": "L-Piscina-WorkerTasks-0",
                    "d": "M374.375,290.3438844680786L378.5416666666667,290.3438844680786C382.7083333333333,290.3438844680786,391.0416666666667,290.3438844680786,399.375,290.3438844680786C407.7083333333333,290.3438844680786,416.0416666666667,290.3438844680786,429.2083333333333,290.3438844680786C442.375,290.3438844680786,460.375,290.3438844680786,469.375,290.3438844680786L478.375,290.3438844680786"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-WorkerTasks LE-EventPipeline",
                    "id": "L-WorkerTasks-EventPipeline-0",
                    "d": "M573.8656104268381,273.3438844680786L586.6953003556984,267.3282370567322C599.5249902845587,261.31258964538574,625.1843701422794,249.28129482269287,648.909893404473,243.26564741134644C672.6354166666666,237.25,694.4270833333334,237.25,705.3229166666666,237.25L716.21875,237.25"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-EventPipeline LE-KafkaProducer",
                    "id": "L-EventPipeline-KafkaProducer-0",
                    "d": "M834.369140625,220.25L862.6474609375,211.75C890.92578125,203.25,947.482421875,186.25,1018.7620442708334,177.75C1090.0416666666667,169.25,1176.0442708333333,169.25,1265.0338541666667,169.25C1354.0234375,169.25,1446,169.25,1517.6328125,169.25C1589.265625,169.25,1640.5546875,169.25,1666.19921875,169.25L1691.84375,169.25"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "markerStart": "url(#flowchart-pointStart)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-EventPipeline LE-Postgres",
                    "id": "L-EventPipeline-Postgres-0",
                    "d": "M839.40625,243.33347498519637L866.8450520833334,246.0435432323434C894.2838541666666,248.75361147949047,949.1614583333334,254.17374797378454,1019.6015625,256.8838162209316C1090.0416666666667,259.5938844680786,1176.0442708333333,259.5938844680786,1265.0338541666667,259.5938844680786C1354.0234375,259.5938844680786,1446,259.5938844680786,1528.984375,259.5938844680786C1611.96875,259.5938844680786,1685.9609375,259.5938844680786,1740.4231770833333,259.5938844680786C1794.8854166666667,259.5938844680786,1829.8177083333333,259.5938844680786,1851.4505208333333,259.5938844680786C1873.0833333333333,259.5938844680786,1881.4166666666667,259.5938844680786,1901.43359375,259.5938844680786C1921.4505208333333,259.5938844680786,1953.1510416666667,259.5938844680786,1985.7174479166667,272.13047694001557C2018.2838541666667,284.6670694119525,2051.7161458333335,309.7402543558265,2068.4322916666665,322.27684682776345L2085.1484375,334.8134392997004"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-KafkaProducer LE-Kafka",
                    "id": "L-KafkaProducer-Kafka-0",
                    "d": "M1828.0625,169.25L1834.1770833333333,169.25C1840.2916666666667,169.25,1852.5208333333333,169.25,1862.8020833333333,169.25C1873.0833333333333,169.25,1881.4166666666667,169.25,1901.43359375,169.25C1921.4505208333333,169.25,1953.1510416666667,169.25,1984.9348958333333,169.33333333333334C2016.71875,169.41666666666666,2048.5859375,169.58333333333334,2064.51953125,169.66666666666666L2080.453125,169.75"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Kafka LE-ClickHouse",
                    "id": "L-Kafka-ClickHouse-0",
                    "d": "M2173.890625,169.75L2186.6484375,169.66666666666666C2199.40625,169.58333333333334,2224.921875,169.41666666666666,2252.511944780033,182.70641870509704C2280.1020145600655,195.99617074352741,2309.7665291201306,222.74234148705486,2324.5987864001636,236.11542685881855L2339.431043680196,249.4885122305823"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-GraphileProducer LE-Postgres",
                    "id": "L-GraphileProducer-Postgres-0",
                    "d": "M1839.75,370.1875L1843.9166666666667,370.1875C1848.0833333333333,370.1875,1856.4166666666667,370.1875,1864.75,370.1875C1873.0833333333333,370.1875,1881.4166666666667,370.1875,1901.43359375,370.1875C1921.4505208333333,370.1875,1953.1510416666667,370.1875,1985.7174479166667,368.02536576875445C2018.2838541666667,365.86323153750885,2051.7161458333335,361.53896307501765,2068.4322916666665,359.3768288437721L2085.1484375,357.2146946125265"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "markerStart": "url(#flowchart-pointStart)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-EventPipeline LE-VMs",
                    "id": "L-EventPipeline-VMs-0",
                    "d": "M829.4780121746431,254.25L858.5715205622026,263.8229166666667C887.665028949762,273.3958333333333,945.852045724881,292.5416666666667,995.6551895291072,307.9540420767096C1045.4583333333333,323.3664174867525,1086.8776041666667,335.0453349735049,1107.5872395833333,340.8847937168812L1128.296875,346.7242524602574"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-VMs LE-KafkaProducer",
                    "id": "L-VMs-KafkaProducer-0",
                    "d": "M1395.796875,358.6258971799881L1419.4934895833333,354.0528309833234C1443.1901041666667,349.47976478665873,1490.5833333333333,340.33363239332937,1547.3922371510355,311.6043161966647C1604.2011409687377,282.875,1670.425719437476,234.5625,1703.5380086718449,210.40625L1736.6502979062138,186.25"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-WorkerTasks LE-VMs",
                    "id": "L-WorkerTasks-VMs-0",
                    "d": "M567.9374880418738,307.3438844680786L581.7551983682282,315.0892089207967C595.5729086945826,322.83453337351483,623.2083293472913,338.325182278951,658.1874980069789,346.0705067316691C693.1666666666666,353.8158311843872,735.4895833333334,353.8158311843872,794.35546875,353.8158311843872C853.2213541666666,353.8158311843872,928.6302083333334,353.8158311843872,987.0442708333334,356.2737551940381C1045.4583333333333,358.731679203689,1086.8776041666667,363.64752722299073,1107.5872395833333,366.1054512326416L1128.296875,368.56337524229247"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-VMs LE-GraphileProducer",
                    "id": "L-VMs-GraphileProducer-0",
                    "d": "M1395.796875,377.53016966788414L1419.4934895833333,376.30639138990347C1443.1901041666667,375.08261311192274,1490.5833333333333,372.6350565559614,1537.9765625,371.4112782779807C1585.3697916666667,370.1875,1632.7630208333333,370.1875,1656.4596354166667,370.1875L1680.15625,370.1875"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "markerStart": "url(#flowchart-pointStart)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-VMs LE-Redis",
                    "id": "L-VMs-Redis-0",
                    "d": "M1395.796875,420.7629038860062L1419.4934895833333,427.19871020728175C1443.1901041666667,433.6345165285573,1490.5833333333333,446.5061291711085,1551.2760416666667,452.9419354923841C1611.96875,459.37774181365967,1685.9609375,459.37774181365967,1740.4231770833333,459.37774181365967C1794.8854166666667,459.37774181365967,1829.8177083333333,459.37774181365967,1851.4505208333333,459.37774181365967C1873.0833333333333,459.37774181365967,1881.4166666666667,459.37774181365967,1901.43359375,459.37774181365967C1921.4505208333333,459.37774181365967,1953.1510416666667,459.37774181365967,1987.7890625,469.3055108612854C2022.4270833333333,479.2332799089111,2060.0026041666665,499.0888180041625,2078.7903645833335,509.01658705178824L2097.578125,518.9443560994139"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "markerStart": "url(#flowchart-pointStart)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-VMs LE-Postgres",
                    "id": "L-VMs-Postgres-0",
                    "d": "M1395.796875,439.66717637390224L1419.4934895833333,449.4522706138618C1443.1901041666667,459.2373648538214,1490.5833333333333,478.80755333374054,1551.2760416666667,488.5926475737001C1611.96875,498.37774181365967,1685.9609375,498.37774181365967,1740.4231770833333,498.37774181365967C1794.8854166666667,498.37774181365967,1829.8177083333333,498.37774181365967,1851.4505208333333,498.37774181365967C1873.0833333333333,498.37774181365967,1881.4166666666667,498.37774181365967,1901.43359375,498.37774181365967C1921.4505208333333,498.37774181365967,1953.1510416666667,498.37774181365967,1987.4812418950344,479.2836020787557C2021.8114421234022,460.18946234385174,2058.771321746805,422.00118287404376,2077.251261558506,402.90704313913983L2095.731201370207,383.81290340423584"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "markerStart": "url(#flowchart-pointStart)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-VMs LE-ClickHouse",
                    "id": "L-VMs-ClickHouse-0",
                    "d": "M1341.0576963853107,446.3125L1373.8775074044254,472.0143693288167C1406.6973184235405,497.7162386576335,1472.3369404617704,549.119977315267,1542.152845230885,574.8218466440836C1611.96875,600.5237159729004,1685.9609375,600.5237159729004,1740.4231770833333,600.5237159729004C1794.8854166666667,600.5237159729004,1829.8177083333333,600.5237159729004,1851.4505208333333,600.5237159729004C1873.0833333333333,600.5237159729004,1881.4166666666667,600.5237159729004,1901.43359375,600.5237159729004C1921.4505208333333,600.5237159729004,1953.1510416666667,600.5237159729004,1992.6380208333333,600.5237159729004C2032.125,600.5237159729004,2079.3984375,600.5237159729004,2123.6627604166665,600.5237159729004C2167.9270833333335,600.5237159729004,2209.1822916666665,600.5237159729004,2248.988291204519,552.6602708498637C2288.7942907423717,504.79682572682697,2327.151081484744,409.0699354807536,2346.32947685593,361.20649035771686L2365.507872227116,313.3430452346802"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "markerStart": "url(#flowchart-pointStart)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-MMDB LE-VMs",
                    "id": "L-MMDB-VMs-0",
                    "d": "M189.0078125,489.3783311843872L199.85807291666666,489.3783311843872C210.70833333333334,489.3783311843872,232.40885416666666,489.3783311843872,247.42578125,489.3783311843872C262.4427083333333,489.3783311843872,270.7760416666667,489.3783311843872,284.96484375,489.3783311843872C299.1536458333333,489.3783311843872,319.1979166666667,489.3783311843872,339.2421875,489.3783311843872C359.2864583333333,489.3783311843872,379.3307291666667,489.3783311843872,393.51953125,489.3783311843872C407.7083333333333,489.3783311843872,416.0416666666667,489.3783311843872,439.0807291666667,489.3783311843872C462.1197916666667,489.3783311843872,499.8645833333333,489.3783311843872,537.609375,489.3783311843872C575.3541666666666,489.3783311843872,613.0989583333334,489.3783311843872,653.1328125,489.3783311843872C693.1666666666666,489.3783311843872,735.4895833333334,489.3783311843872,794.35546875,489.3783311843872C853.2213541666666,489.3783311843872,928.6302083333334,489.3783311843872,987.0442708333334,480.95499573150965C1045.4583333333333,472.53166027863216,1086.8776041666667,455.68498937287717,1107.5872395833333,447.2616539199996L1128.296875,438.8383184671221"
                  }}></path></g><g parentName="g" {...{
                  "className": "edgeLabels"
                }}><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1262.046875, 169.25)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-101.203125, -19)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "38",
                        "width": "202.40625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`create/update`}<br parentName="span"></br>{`events,persons,groups,...`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1537.9765625, 259.5938844680786)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-117.1796875, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "234.359375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`updates to persons,groups,...`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(2250.4375, 169.25)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-52.046875, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "104.09375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`Kafka engine`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1004.0390625, 311.6875)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-99.2578125, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "198.515625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`processEvent,onEvent,...`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1537.9765625, 331.1875)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-51.9140625, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "103.828125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`Create event`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(777.8125, 353.8158311843872)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-101.96875, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "203.9375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`runJob,runEveryMinute,...`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1537.9765625, 370.1875)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-49.9296875, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "99.859375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`Enqueue job`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1759.953125, 459.37774181365967)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-66.421875, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "132.84375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`Cache extension`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1759.953125, 498.37774181365967)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-72.84375, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "145.6875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`Storage extension`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1984.8515625, 600.5237159729004)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-70.1015625, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "140.203125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`Historical exports`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(537.609375, 489.3783311843872)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-88.234375, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "176.46875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`GeoIP lookups via TCP`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "nodes"
                }}><g parentName="g" {...{
                    "transform": "translate(2126.671875, 534.3179836273193)",
                    "id": "flowchart-Redis-134",
                    "className": "node default default"
                  }}><path parentName="g" {...{
                      "transform": "translate(-29.09375,-28.911463664278404)",
                      "d": "M 0,7.940975776185602 a 29.09375,7.940975776185602 0,0,0 58.1875 0 a 29.09375,7.940975776185602 0,0,0 -58.1875 0 l 0,41.9409757761856 a 29.09375,7.940975776185602 0,0,0 58.1875 0 l 0,-41.9409757761856",
                      "style": {}
                    }}></path><g parentName="g" {...{
                      "transform": "translate(-21.59375, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "43.1875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Redis`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(156.0546875, 153.3783311843872)",
                    "id": "flowchart-KafkaConsumer-138",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "146.109375",
                      "y": "-17",
                      "x": "-73.0546875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-65.5546875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "131.109375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka Consumer`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(339.2421875, 290.3438844680786)",
                    "id": "flowchart-Piscina-142",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "70.265625",
                      "y": "-17",
                      "x": "-35.1328125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-27.6328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "55.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Piscina`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(156.0546875, 237.3783311843872)",
                    "id": "flowchart-PubSub-141",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "75.125",
                      "y": "-17",
                      "x": "-37.5625",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-30.0625, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "60.125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`PubSub`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(156.0546875, 321.3783311843872)",
                    "id": "flowchart-Graphile-139",
                    "className": "node default OptionalServices"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "138.03125",
                      "y": "-17",
                      "x": "-69.015625",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-61.515625, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "123.03125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Graphile queue`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(156.0546875, 405.3783311843872)",
                    "id": "flowchart-Schedule-143",
                    "className": "node default OptionalServices"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "88.53125",
                      "y": "-17",
                      "x": "-44.265625",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-36.765625, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "73.53125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Schedule`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(537.609375, 290.3438844680786)",
                    "id": "flowchart-WorkerTasks-144",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "118.46875",
                      "y": "-17",
                      "x": "-59.234375",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-51.734375, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "103.46875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Worker tasks`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(777.8125, 237.25)",
                    "id": "flowchart-EventPipeline-147",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "123.1875",
                      "y": "-17",
                      "x": "-61.59375",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-54.09375, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "108.1875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`eventPipeline`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1759.953125, 169.25)",
                    "id": "flowchart-KafkaProducer-149",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "136.21875",
                      "y": "-17",
                      "x": "-68.109375",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-60.609375, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "121.21875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka producer`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(2126.671875, 351.8438844680786)",
                    "id": "flowchart-Postgres-136",
                    "className": "node default default"
                  }}><path parentName="g" {...{
                      "transform": "translate(-41.5234375,-31.96901990236575)",
                      "d": "M 0,9.979346601577168 a 41.5234375,9.979346601577168 0,0,0 83.046875 0 a 41.5234375,9.979346601577168 0,0,0 -83.046875 0 l 0,43.97934660157717 a 41.5234375,9.979346601577168 0,0,0 83.046875 0 l 0,-43.97934660157717",
                      "style": {}
                    }}></path><g parentName="g" {...{
                      "transform": "translate(-34.0234375, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "68.046875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Postgres`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(2126.671875, 169.25)",
                    "id": "flowchart-Kafka-137",
                    "className": "node default default"
                  }}><polygon parentName="g" {...{
                      "style": {},
                      "transform": "translate(-46.71875,46.71875)",
                      "className": "label-container",
                      "points": "46.71875,0 93.4375,-46.71875 46.71875,-93.4375 0,-46.71875"
                    }}></polygon><g parentName="g" {...{
                      "transform": "translate(-22.21875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "44.4375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(2379.1171875, 279.3783311843872)",
                    "id": "flowchart-ClickHouse-135",
                    "className": "node default default"
                  }}><path parentName="g" {...{
                      "transform": "translate(-51.6328125,-33.96471353275378)",
                      "d": "M 0,11.309809021835854 a 51.6328125,11.309809021835854 0,0,0 103.265625 0 a 51.6328125,11.309809021835854 0,0,0 -103.265625 0 l 0,45.309809021835854 a 51.6328125,11.309809021835854 0,0,0 103.265625 0 l 0,-45.309809021835854",
                      "style": {}
                    }}></path><g parentName="g" {...{
                      "transform": "translate(-44.1328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "88.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`ClickHouse`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1759.953125, 370.1875)",
                    "id": "flowchart-GraphileProducer-148",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "159.59375",
                      "y": "-17",
                      "x": "-79.796875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-72.296875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "144.59375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Graphile producer`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1120.796875, 314.5625)",
                    "className": "root"
                  }}><g parentName="g" {...{
                      "className": "clusters"
                    }}><g parentName="g" {...{
                        "id": "VMs",
                        "className": "cluster default"
                      }}><rect parentName="g" {...{
                          "height": "123.75",
                          "width": "267.5",
                          "y": "8",
                          "x": "8",
                          "ry": "0",
                          "rx": "0",
                          "style": {}
                        }}></rect><g parentName="g" {...{
                          "transform": "translate(98.171875, 13)",
                          "className": "cluster-label"
                        }}><foreignObject parentName="g" {...{
                            "height": "19",
                            "width": "87.15625"
                          }}><div parentName="foreignObject" {...{
                              "style": {
                                "display": "inline-block",
                                "whiteSpace": "nowrap"
                              },
                              "xmlns": "http://www.w3.org/1999/xhtml"
                            }}><span parentName="div" {...{
                                "className": "nodeLabel"
                              }}>{`Plugin VMs`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                      "className": "edgePaths"
                    }}></g><g parentName="g" {...{
                      "className": "edgeLabels"
                    }}></g><g parentName="g" {...{
                      "className": "nodes"
                    }}><g parentName="g" {...{
                        "transform": "translate(79.875, 69.875)",
                        "id": "flowchart-VM1-145",
                        "className": "node default default"
                      }}><polygon parentName="g" {...{
                          "style": {},
                          "transform": "translate(-36.875,36.875)",
                          "className": "label-container",
                          "points": "36.875,0 73.75,-36.875 36.875,-73.75 0,-36.875"
                        }}></polygon><g parentName="g" {...{
                          "transform": "translate(-12.375, -9.5)",
                          "style": {},
                          "className": "label"
                        }}><foreignObject parentName="g" {...{
                            "height": "19",
                            "width": "24.75"
                          }}><div parentName="foreignObject" {...{
                              "style": {
                                "display": "inline-block",
                                "whiteSpace": "nowrap"
                              },
                              "xmlns": "http://www.w3.org/1999/xhtml"
                            }}><span parentName="div" {...{
                                "className": "nodeLabel"
                              }}>{`VM`}</span></div></foreignObject></g></g><g parentName="g" {...{
                        "transform": "translate(203.625, 69.875)",
                        "id": "flowchart-VM2-146",
                        "className": "node default default"
                      }}><polygon parentName="g" {...{
                          "style": {},
                          "transform": "translate(-36.875,36.875)",
                          "className": "label-container",
                          "points": "36.875,0 73.75,-36.875 36.875,-73.75 0,-36.875"
                        }}></polygon><g parentName="g" {...{
                          "transform": "translate(-12.375, -9.5)",
                          "style": {},
                          "className": "label"
                        }}><foreignObject parentName="g" {...{
                            "height": "19",
                            "width": "24.75"
                          }}><div parentName="foreignObject" {...{
                              "style": {
                                "display": "inline-block",
                                "whiteSpace": "nowrap"
                              },
                              "xmlns": "http://www.w3.org/1999/xhtml"
                            }}><span parentName="div" {...{
                                "className": "nodeLabel"
                              }}>{`VM`}</span></div></foreignObject></g></g></g></g><g parentName="g" {...{
                    "transform": "translate(156.0546875, 489.3783311843872)",
                    "id": "flowchart-MMDB-150",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "65.90625",
                      "y": "-17",
                      "x": "-32.953125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-25.453125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "50.90625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`MMDB`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(156.0546875, 573.3783311843872)",
                    "id": "flowchart-HttpServer-140",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "113.5",
                      "y": "-17",
                      "x": "-56.75",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-49.25, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "98.5"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`HTTP Server`}</span></div></foreignObject></g></g></g></g></g></g></g></svg></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      